'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (EnumCookiesAuth) {
    EnumCookiesAuth["ACCESS_TOKEN"] = "AccessToken";
    EnumCookiesAuth["END_USER_ID"] = "EndUserId";
    EnumCookiesAuth["EXPIRATION_ACCESS_TOKEN"] = "ExpirationAccessToken";
})(exports.EnumCookiesAuth || (exports.EnumCookiesAuth = {}));
//# sourceMappingURL=EnumCookiesAuth.js.map
